module.exports = __webpack_public_path__ + "static/img/female-bg-es.fba970fd.png";